import { render, staticRenderFns } from "./RoundAvatar.vue?vue&type=template&id=54ccd02a&scoped=true&"
import script from "./RoundAvatar.vue?vue&type=script&lang=ts&"
export * from "./RoundAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./RoundAvatar.vue?vue&type=style&index=0&id=54ccd02a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ccd02a",
  null
  
)

export default component.exports